module.exports = __webpack_public_path__ + "static/media/trees.94ecbc97.svg";